/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddTaskExcuseCommand } from '../../models/add-task-excuse-command';
import { AddTaskExcuseCommandResult } from '../../models/add-task-excuse-command-result';

export interface ApiTaskAddTaskExcusePut$Plain$Params {
      body?: AddTaskExcuseCommand
}

export function apiTaskAddTaskExcusePut$Plain(http: HttpClient, rootUrl: string, params?: ApiTaskAddTaskExcusePut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AddTaskExcuseCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiTaskAddTaskExcusePut$Plain.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AddTaskExcuseCommandResult>;
    })
  );
}

apiTaskAddTaskExcusePut$Plain.PATH = '/api/Task/AddTaskExcuse';
